import makeApiCall from "../master/axiosIndex";

const dropdownApis = {
  getProjectsDropdown: (siteIds: number): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/project/dropdown`,
      params: { siteIds },
    }),
  fetchContractorsBySiteIdDropdown: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/buyer/fetchContractorBySiteId`,
      data,
    }),
  materialBOQDropDown: (siteIds: number): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/inventory/consumptionTarget/dropdown`,
      params: { siteIds, remainingRequestedQty: true },
    }),
  workCategoryDropDown: (): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/masters/workCatgoriesList`,
    }),
  materialBoQMaterialLinesDrioDown: (targetId: number): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/inventory/consumptionTarget/view`,
      params: { targetId },
    }),
  workUomDropDown: (): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/masters/workUomsList`,
    }),
  fetchBlockBySiteId: (id: number): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/buyer/fetchBlockById`,
      params: { id },
    }),
  fetchActivityDropdown: (projectId: number): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/activity/dropdown`,
      params: { projectId },
    }),
  getStatesByCountry: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/misc/stateByCountry`,
      params: { countryId: 1 },
    }),
};

export default dropdownApis;
